// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"828":"31cd80a4","968":"6895ab42"}[chunkId] + ".chunk.js";
};